import React from "react";
import styles from "./baseCarousel.scss";

export const carouselDefaultConfig = {
	dots: true,
	infinite: true,
	speed: 500,
	slidesToShow: 3,
	slidesToScroll: 3,
	initialSlide: 0,
    slide: "ul",
	draggable: true,
	className: "slider",
	dotsClass: "dots",
	customPaging: i => <button></button>,
	responsive: [
		{
			breakpoint: 3000,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 3,
			},
		},
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2,
			},
		},
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2,
			},
		},
		{
			breakpoint: 674,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
			},
		},
		{
			breakpoint: 425,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
			},
		},
	],
};
